import { Address } from './address';

export class DecisionAddress extends Address {
    addressYears?: number;
    addressMonths?: number;
    order?: number;
}
